import src from "IMAGE";
export default { src, width: 750, height: 365, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAKUlEQVR42oXKMQ0AAAgDsOEE/0qwQYIBLj6Gg3H0K6aDCracCphG5Q0HBJljgd6V5tQAAAAASUVORK5CYII="};
